<h1 class="mt-5">Mantenedor de secciones</h1>

<div class="row mt-5">
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label><label
            class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroAnyoSeleccionado" (ngModelChange)="seleccionFiltro('anho')"
        [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }">
            <option [value]="0">Seleccionar</option>
            <option *ngFor="let anyo of filtroAnhos" [value]="anyo">{{anyo}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback">
            <div *ngIf="tieneErrores['anyo']">Campo requerido</div>
        </div>
    </div>
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label><label
            class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
            <select class="form-control select_criterios" [(ngModel)]="filtroPeriodoSeleccionado" (ngModelChange)="seleccionFiltro('periodo')"
            [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
                <option [value]="0">Seleccionar</option>
                <option *ngFor="let periodo of filtroPeriodos" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
            </select>
            <div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback">
                <div *ngIf="tieneErrores['periodo']">Campo requerido</div>
            </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label><label
            class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
            <select class="form-control select_criterios" [(ngModel)]="filtroSedeSeleccionado" (ngModelChange)="seleccionFiltro('sede')"
            [ngClass]="{ 'is-invalid': submitted && tieneErrores['sede'] }">
                <option [value]="0">Seleccionar</option>
                <option *ngFor="let sede of filtroSedes" [value]="sede.sedeId">{{sede.descripcion}}</option>
            </select>
            <div *ngIf="submitted && tieneErrores['sede']" class="invalid-feedback">
                <div *ngIf="tieneErrores['sede']">Campo requerido</div>
            </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sección</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroSeccionSeleccionado">
            <option [value]="0">Seleccionar</option>
            <option *ngFor="let seccion of filtroSecciones" [value]="seccion.id">{{seccion.descSeccion}}</option>
        </select>
    </div>
    <div class="col-1 centrar_iconos_botones mt-4">
        <button class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR" (click)="busqueda()"><i
                class="bi bi-search"></i></button>
    </div>
    <div class="col-1 centrar_iconos_botones mt-4">
        <button class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top"
            title="ELIMINAR" alt="ELIMINAR" (click)="limpiarFiltros('')"><i class="bi bi-x"></i></button>
    </div>
</div>
<div class="row mt-3">
    
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Estado</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroEstadoSeleccionado">
            <option [value]="0">Seleccionar</option>
            <option *ngFor="let estado of filtroEstados" [value]="estado.id">{{estado.descripcion}}</option>
        </select>
    </div>
</div>

<div *ngIf="error" class="alert alert-danger tipografía_alertas mt-4 mb-4" role="alert">
    <i class="bi bi bi-x-circle tamanio_iconos-boton mr-2"></i>
    {{ error }}
</div>

<div class="alert alert-success tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeExito !== ''">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeExito}}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
        <span aria-hidden="true" class="alert-success">&times;</span>
    </button>
</div>

<div class="row align-items-baseline">
    <div class="col-5">
        <ul class="nav nav-tabs mt-5" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="gestion-secciones" data-toggle="tab" href="#home" role="tab" aria-controls="home"
                    aria-selected="true" (click)="reajustarTabla()">Gestión secciones</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="procesos-masivos" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                    aria-selected="false" (click)="reajustarTabla()">Procesos masivos</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="procesos-masivos" data-toggle="tab" href="#reenvio-sap" role="tab" aria-controls="reenvio-sap"
                    aria-selected="false" (click)="reajustarTabla('reenvioSap')">Reenvío SAP</a>
            </li>
        </ul>
    </div>
    <div class="col d-flex justify-content-end" *ngIf="seccionesSeleccionadas != 0">
        <p *ngIf="mostrarCheckbox == 'A'">¿Quieres modificar <strong>{{seccionesSeleccionadas}}</strong> sección(es) a estado <strong>cerrado</strong>?</p>
        <p *ngIf="mostrarCheckbox == 'C'">¿Quieres modificar <strong>{{seccionesSeleccionadas}}</strong> sección(es) a estado <strong>abierto</strong>?</p>
    </div>
    <div class="col-3 d-flex justify-content-end">
        <button class="boton-primario" data-toggle="modal" data-target="#confirmar" style="z-index: 1;" *ngIf="seccionesSeleccionadas != 0">CONFIRMAR</button>
    </div>
    

    
</div>

<div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="gestion-secciones">
        <!-- TABLA -->
        <div style="margin-top: 20px;">
            <table *ngIf="renderTableGestion" id="tabla-gestion" [dtOptions]="dtOptions3" datatable class="row-border hover table-striped display nowrap" aria-describedby="tabla secciones">
                <thead class="header_tabla">
                    <tr>
                        <th class="text-center" style="width: 5%;">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" *ngIf="mostrarCheckbox != ''" (change)="seleccionarTodos($event)">
                            </div>
                        </th>
                        <th>Año</th>
                        <th>Periodo</th>
                        <th>Asignatura</th>
                        <th>ID Sección</th>
                        <th>Sección</th>
                        <th class="text-center">Descargar acta</th>
                        <th>Estado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let seccion of listaSecciones; index as ind">
                        <td class=" text-center">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" [checked]="seccionChecked(seccion)" *ngIf="validarVisualizacionCheckbox(seccion)" (change)="calcularSeleccionadas(seccion, $event)">
                            </div>
                        </td>
                        <td class=""><p class="celda">{{seccion.anoAcademico}}</p></td>
                        <td class=""><p class="celda">{{seccion.periodoAcademicoId}}</p></td>
                        <td class=""><p class="celda">{{seccion.asignatura}}</p></td>
                        <td class=""><p class="celda">{{seccion.idSeccion}}</p></td>
                        <td class=""><p class="celda">{{seccion.seccion}}</p></td>
                        <td class="text-center">
                            <button class="btn p-0" data-toggle="tooltip"
                                data-placement="top" title="DESCARGAR ACTA" alt="DESCARGAR ACTA" (click)="descargarActa(seccion.estado,seccion.idSeccion)">
                                <i class="bi bi-filetype-pdf icono-tabla" *ngIf="seccion.estado == 'C' && seccion.actaCierre"></i>
                                <i class="bi bi-dash icono-tabla" *ngIf="seccion.estado != 'C'"></i>
                            </button>
                        </td>
                        <td class="">
                            <p class="celda" *ngIf="seccion.estado == 'A'">Abierta</p>
                            <p class="celda" *ngIf="seccion.estado == 'C'">Cerrada</p>
                            <p class="celda" *ngIf="seccion.estado == 'P'">En Proceso</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table *ngIf="!renderTableGestion" [dtOptions]="dtOptions3" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla secciones">
                <thead class="header_tabla">
                    <tr>
                        <th class="text-center" style="width: 5%;">
                            
                        </th>
                        <th>Año</th>
                        <th>Periodo</th>
                        <th>Asignatura</th>
                        <th>ID Sección</th>
                        <th>Sección</th>
                        <th class="text-center">Descargar acta</th>
                        <th>Estado</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
        <!-- FIN TABLA -->
    </div>
    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="procesos-masivos">
         <!-- TABLA -->
         <div style="margin-top: 20px;">
            <table *ngIf="renderTableMasiva" id="tabla-procesos-masivos" [dtOptions]="dtOptions2" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla secciones">
                <thead class="header_tabla">
                    <tr>
                        <th>Fecha</th>
                        <th>Proceso</th>
                        <th>Año</th>
                        <th>Periodo</th>
                        <th>Sede</th>
                        <th>Usuario</th>
                        <th>Cant. Secciones</th>
                        <th>Fecha envío SAP</th>
                        <th>ID carga SAP</th>
                        <th>Estado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let seccion of listaMasiva">
                        <td class="py-3"><p class="celda">{{seccion.fecha}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.proceso}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.anyoAcademico}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.periodoAcademicoId}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.sede}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.usuario}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.cantidadSecciones}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.fechaEnviadoSap}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.idCargaOut}}</p></td>
                        <td class="py-3"><p class="celda">{{seccion.estado}}</p></td>
                    </tr>
                </tbody>
            </table>
            <table *ngIf="!renderTableMasiva" [dtOptions]="dtOptions2" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla secciones">
                <thead class="header_tabla">
                    <tr>
                        <th>Fecha</th>
                        <th>Proceso</th>
                        <th>Año</th>
                        <th>Periodo</th>
                        <th>Sede</th>
                        <th>Usuario</th>
                        <th>Cant. Secciones</th>
                        <th>Fecha envío SAP</th>
                        <th>ID carga SAP</th>
                        <th>Estado</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
        <!-- FIN TABLA -->
    </div>

    <!-- Reenvio SAP -->
    <div class="tab-pane fade" id="reenvio-sap" role="tabpanel" aria-labelledby="reenvio-sap">
        <div style="margin-top: 20px;"></div>
        <table *ngIf="renderTableReenvioSap" id="tabla-reenvio-sap" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap" aria-describedby="tabla reenvio sap">
            <thead class="header_tabla">
                <tr>
                    <th class="text-center" style="width: 5%;">
                        
                    </th>
                    <th>Año</th>
                    <th>Periodo</th>
                    <th>Asignatura</th>
                    <th>ID Sección</th>
                    <th>Sección</th>
                    <th>Error envío a SAP</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let error of listaReenvioSap">
                    <td class="text-center">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" [checked]="error.checked" (change)="seleccionErrorSap(error, $event)">
                        </div>
                    </td>
                    <td>{{ error?.anoAcademico }}</td>
                    <td>{{ error?.periodoAcademicoId }}</td>
                    <td>{{ error?.asignatura }}</td>
                    <td>{{ error?.idSeccion }}</td>
                    <td>{{ error?.seccion }}</td>
                    <td>
                        <p class="cursor-pointer text-underline" (click)="obtenerDetalleErrorSap(error.seccionEvaluacionId)">Ver registro</p>
                    </td>
                </tr>
            </tbody>
        </table>

        <table *ngIf="!renderTableReenvioSap" [dtOptions]="dtOptions" datatable class="row-border hover table table-striped display nowrap " aria-describedby="tabla reenvio sap">
            <thead class="header_tabla">
                <tr>
                    <th class="text-center">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="seleccionarTodosReenvioSap" (change)="seleccionarTodoReenvioSap($event)" value="option1">
                        </div>
                    </th>
                    <th>Año</th>
                    <th>Periodo</th>
                    <th>Asignatura</th>
                    <th>ID Sección</th>
                    <th>Sección</th>
                    <th>Error envío a SAP</th>
                </tr>
            </thead>
        </table>

        <div class="text-center">
            <button *ngIf="reenvioSapDisponible()" (click)="reenviarListaSap()" class="boton-secundario" style="z-index: 1;">Reenviar a SAP</button>
        </div>
    </div>
    <!-- Fin reenvio SAP -->
</div>

<!-- MODAL CONFIRMAR -->
<div class="modal fade" id="confirmar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header align-items-center">
                <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
                    <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="row align-items-center my-3 mx-4">
                        <p class="mb-0 ml-3" *ngIf="mostrarCheckbox == 'A' && seccionesSeleccionadas == 1">¿Estás seguro/a que deseas cerrar la sección?</p>
                        <p class="mb-0 ml-3" *ngIf="mostrarCheckbox == 'C' && seccionesSeleccionadas == 1">¿Estás seguro/a que deseas abrir la sección?</p>
                        <p class="mb-0 ml-3" *ngIf="mostrarCheckbox == 'A' && seccionesSeleccionadas != 1">¿Estás seguro/a que deseas cerrar las {{seccionesSeleccionadas}} secciones?</p>
                        <p class="mb-0 ml-3" *ngIf="mostrarCheckbox == 'C' && seccionesSeleccionadas != 1">¿Estás seguro/a que deseas abrir las {{seccionesSeleccionadas}} secciones?</p>
                        <span class="ml-3 mt-2">Al presionar el botón SI, los estados de las secciones quedarán en proceso
                            hasta que se realice la validación.</span>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-center">
                <div class="my-4">
                        <button class="boton-secundario boton_secundario_modal ml-3" data-toggle="tooltip" data-placement="top"
                        title="SI" alt="SI" (click)="confirmarAccion()" data-dismiss="modal">SI</button>
                    <button class="boton-primario ml-3" data-toggle="tooltip" data-placement="top"
                        title="NO" alt="NO" data-dismiss="modal">NO</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- FIN MODAL CONFIRMAR -->

<!-- Modal detalle err sap -->
<button id="modal-detalle-err-sap-btn" class="btn d-none" data-toggle="modal" data-target="#modal-detalle-err-sap">Registro procesamiento</button>
<div class="modal fade" id="modal-detalle-err-sap" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-body">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-6">
                        <h1>Registro procesamiento envío de promedios a SAP</h1>
                    </div>
                    <div class="col"></div>
                </div>
                <div class="container mt-5 mb-4">
                    <div class="row">
                        <div class="col"></div>
                        <div class="col-11 fondo-gris-info-err">
                            <div class="row">
                                <div class="col-6">
                                    <p class="py-1 pt-4">Asignatura: <b>{{ detalleErrSapModal?.informacion?.asignatura }}</b></p>
                                    <p class="py-1 pb-4">Usuario envío SAP: <b>{{ detalleErrSapModal?.informacion?.nombreUsuarioSap }}</b></p>
                                </div>
                                <div class="col-6">
                                    <p class="py-1 pt-4">Periodo: <b>{{ detalleErrSapModal?.informacion?.periodoCodigo }}</b></p>
                                    <p class="py-1 pb-4">Fecha envío SAP: <b>{{ detalleErrSapModal?.informacion?.fechaEnviadoSap }}</b></p>
                                </div>
                            </div>
                        </div>
                        <div class="col"></div>
                    </div>
                    <div class="row">
                        <div class="col"></div>
                        <div class="col-11 mx-0 p-0 mt-2">
                            <table class="row-border hover table table-striped display nowrap" aria-describedby="tabla detalle reenvio sap">
                                <thead>
                                    <tr>
                                        <th>Nº Rut</th>
                                        <th>Nombre Alumno</th>
                                        <th>Descripción error</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let error of detalleErrSapModal?.listado">
                                        <td>{{ error?.rut }}</td>
                                        <td>{{ error?.nombre }}</td>
                                        <td>{{ error?.mensaje }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col"></div>
                    </div>
                </div>

				<div class="text-center">
                    <button class="boton-secundario" data-dismiss="modal" id="btn-modal-eliminar-dismiss">
                        Cerrar
                    </button>
                </div>
			</div>
		</div>
  </div>
</div>
<!-- FIN Modal detalle err sap -->
